import {ProductScrollList, ProductType,ArticleScrollList, InstagramImageGrid} from "./product_item.js";
import {add2basket,fvBindingEvents} from "./basket";
import {
  rootUrl,
  ARTICLE_LINK,
  sliderViewportWSwitch,
  articleItemWidth,
  sliderMaxItems,
  contentProductBoxHeight,
  productItemWith
} from "./config";

var h = React.createElement;
var productList = productList || {};

function productTopsale() {
  var ele = $("#topsale_products");
  if (ele.length == 0) return;
  var props = {
    title: $("#topsale_products").data("title-text"),
    ajax_url: `${rootUrl}/product/topsale`,
    ele_id: "topsale_products",
    type: "topsale_product",
    page: 1,
    showAll: $("#topsale_products").data("btn-text"),
    isShowAll: false,
    showall_url:`${rootUrl}/product/topsale`
  };
  var ts = h(ProductScrollList, props);
  productList[$(ele).attr("id")] = ReactDOM.render(ts, $('#topsale_products')[0]);
}

function articlesLatest() {
  var ele = $("#latest_articles");
  if (ele.length == 0) return;
  var props = {
    title: $("#latest_articles").data("title-text"),
    url: `${rootUrl}/articles/latest`,
    ele_id: "latest_articles",
    type: "latest_articles",
    page: 1,
    itemWidth: articleItemWidth,
    minSlides: 1,
    showAll: $("#latest_articles").data("btn-text"),
    isShowAll: false,
    showall_url:`${rootUrl}/${ARTICLE_LINK}`
  };
  var ts = h(ArticleScrollList, props);
  productList[$(ele).attr("id")]=ReactDOM.render(ts, $('#latest_articles')[0]);
}

function articlesRelated() {
  var ele = $("#articles_related");
  if (ele.length == 0) return;

  var props = {
    title: $("#articles_related").data("title-text"),
    url: `${rootUrl}/articles/related?`+ele.data("p1")+"="+ele.data("p1val")+"&"+ele.data("p2")+"="+ele.data("p2val"),
    ele_id: "articles_related",
    type: "articles_related",
    page: 1,
    itemWidth: articleItemWidth,
    minSlides: 1,
    showAll: $("#articles_related").data("btn-text"),
    isShowAll: false,
    showall_url:`${rootUrl}/${ARTICLE_LINK}`
  };
  var ts = h(ArticleScrollList, props);
  productList[$(ele).attr("id")]=ReactDOM.render(ts, $('#articles_related')[0]);
}

function productLatest() {
  var ele = $("#latest_products");
  if (ele.length == 0) return;
  var props = {
    title: $("#latest_products").data("title-text"),
    ajax_url: `${rootUrl}/product/latest`,
    ele_id: "latest_products",
    type: "latest_product",
    page: 1,
    showAll: $("#latest_products").data("btn-text"),
    isShowAll: false,
    showall_url:`${rootUrl}/product/latest?page=1&count=${sliderMaxItems}`,
    width: productItemWith
  };
  var ts = h(ProductScrollList, props);
  productList[$(ele).attr("id")] = ReactDOM.render(ts, $('#latest_products')[0]);
}

function productDirectSearch() {
  var ele = $("#directSearch_products");
  if (ele.length == 0) return;
  let isCreateSlider=$(ele).data("slider-init")=="yes";
  let pName=$("#directSearch_products").data("para-name"),
      pValue=$("#directSearch_products").data("para-val");
  var props = {
    title: $("#directSearch_products").data("title-text"),
    ajax_url: `${rootUrl}/product/directquery?${pName}=${pValue}`,
    ele_id: "directSearch_products",
    type: "search_product",
    page: 1,
    showAll: $("#directSearch_products").data("btn-text"),
    isShowAll: false,
    notCreatedSlider: !isCreateSlider
  };
  var ts = h(ProductScrollList, props);
  productList[$(ele).attr("id")] = ReactDOM.render(ts, $('#directSearch_products')[0]);
}

function ProductTypeList() {
  var ele = $("#product_type_list");
  if (ele.length == 0) return;

  var props = {
    title: $("#product_type_list").data("title-text"),
    url: `${rootUrl}/product/type`,
    ptype_id: $("#product_type_list").data("list-id"),
    ele_id: "product_type_list",
    type: "product_type",
    page: 1,
    showAll: $("#product_type_list").data("btn-text"),
    isShowAll: true,
    isSortable: true,
    sortopts: {"availability":$("#product_type_list").data("avail-txt"),
               "name":$("#product_type_list").data("name-txt"),
               "price":$("#product_type_list").data("price-txt"),
               "latest":$("#product_type_list").data("latest-txt")
              },
    defaultSort: $("#product_type_list").data("default-sort-order"),
    availability: $("#product_type_list").data("sort-availability"),
  };
  var ts = h(ProductType, props);
  productList[$(ele).attr("id")] = ReactDOM.render(ts, $('#product_type_list')[0]);
}

function ProductTopSaleInContentList() {
  var ele=$("#content_topsale_products");
  if (ele.length == 0) return;
  let ptypeName=$(ele).data("type");
  let ptypeVal=$(ele).data("type-para");
  let plimitVal=$(ele).data("limit");
  let isCreateSlider=$(ele).data("slider-init") == "yes";
  let wSize = $(window).width();
  let initSize=Number($(ele).data("slider-init-size"));
  initSize = isNaN(initSize)?0:Number(initSize);
  if(initSize && wSize > initSize) {
    isCreateSlider=false;
    let cHeight = Number($("div.content-article1-container").height());
    //cHeight += Number($("div.content-article1-container div.gan-snippet").height());
    plimitVal=Math.floor(Number(cHeight - 64)/contentProductBoxHeight)*2; // there are 64px including padding and list header
  }
  var props = {
    title: $(ele).data("title-text"),
    ajax_url: `${rootUrl}/articles/product/topsale?${ptypeName}=${ptypeVal}&limit=${plimitVal}`,
    method: "POST",
    ptype_id: $(ele).data("list-id"),
    ele_id: "content_topsale_products",
    type: "product_topsale_content",
    page: 1,
    showAll: $(ele).data("btn-text"),
    isShowAll: false,
    isSortable: false,
    notCreatedSlider: !isCreateSlider
  };
  var ts = h(ProductScrollList, props);
  productList[$(ele).attr("id")] = ReactDOM.render(ts, $('#content_topsale_products')[0]);
}

function TopSaleProductsScrollList() {
  var lists = $("div.topsale-products-container");
  lists.each(function(idx, list){
    var props = {
      title: $(list).data("title-text"),
      ajax_url: `${rootUrl}/product/topsale?type=${$(list).data("type")}&${$(list).data("type-para")}=${$(list).data("list-id")}`,
      ele_id: $(list).attr("id"),
      type: "topsale_product",
      page: 1,
      showAll: $(list).data("btn-text"),
      isShowAll: false,
      showall_url:`${rootUrl}/product/topsale`
    };
    var ts = h(ProductScrollList, props);
    productList[$(list).attr("id")] = ReactDOM.render(ts, list);
  });
}

function RelatedProductsScrollList() {
  var lists = $("div.related-products-container");
  lists.each(function(idx, list){
    var props = {
      title: $(list).data("title-text"),
      ajax_url: `${rootUrl}/product/relate?`+$(list).data("p1")+"="+$(list).data("p1val")+"&"+$(list).data("p2")+"="+$(list).data("p2val"),
      ele_id: $(list).attr("id"),
      type: "related_product",
      page: 1,
      showAll: $(list).data("btn-text"),
      isShowAll: false,
      showall_url:`${rootUrl}/product/relate`
    };
    var ts = h(ProductScrollList, props);
    productList[$(list).attr("id")] = ReactDOM.render(ts, list);
  });
}
function TipsProductsScrollList() {
  var lists = $("div.tips-products-container");
  lists.each(function(idx, list){
    var props = {
      title: $(list).data("title-text"),
      ajax_url: `${rootUrl}/product/tips?` + $(list).data("para") + "=" + $(list).data("search-value"),
      ele_id: $(list).attr("id"),
      type: "tipon_product",
      page: 1,
      showAll: $(list).data("btn-text"),
      isShowAll: false,
      showall_url:`${rootUrl}/product/tips`
    };
    var ts = h(ProductScrollList, props);
    productList[$(list).attr("id")] = ReactDOM.render(ts, list);
  });
}

function SameAsProductsScrollList() {
  var lists = $("div.sameby-products-container");
  lists.each(function(idx, list){
    let p3="";
    if($(list).data("p3")) p3=`&${$(list).data("p3")}=${$(list).data("p3val")}`;
    var props = {
      title: $(list).data("title-text"),
      ajax_url: `${rootUrl}/product/sameby?`+$(list).data("p1")+"="+$(list).data("p1val")+"&"+$(list).data("p2")+"="+$(list).data("p2val")+p3,
      ele_id: $(list).attr("id"),
      type: "sameby_product",
      page: 1,
      showAll: $(list).data("btn-text"),
      isShowAll: false,
      showall_url:`${rootUrl}/product/sameby`
    };
    var ts = h(ProductScrollList, props);
    productList[$(list).attr("id")] = ReactDOM.render(ts, list);
  });
}

function CrossSaleProductsScrollList() {
  var lists = $("div.crossale-products-container");
  lists.each(function(idx, list){
    var props = {
      title: $(list).data("title-text"),
      ajax_url: `${rootUrl}/product/crosssale?`+$(list).data("p1")+"="+$(list).data("p1val")+"&"+$(list).data("p2")+"="+$(list).data("p2val"),
      ele_id: $(list).attr("id"),
      type: "crossale_product",
      page: 1,
      showAll: $(list).data("btn-text"),
      isShowAll: false,
      showall_url:`${rootUrl}/product/crosssale`
    };
    var ts = h(ProductScrollList, props);
    productList[$(list).attr("id")] = ReactDOM.render(ts, list);
  });
};

function FreeshipProductsScrollList() {
  var lists = $("div.freeship-products-container");
  lists.each(function(idx, list){
    var props = {
      title: $(list).data("title-text"),
      ajax_url: `${rootUrl}/product/freeship?`+$(list).data("p1")+"="+$(list).data("p1val")+"&"+$(list).data("p2")+"="+$(list).data("p2val"),
      ele_id: $(list).attr("id"),
      type: "freeship_product",
      page: 1,
      showAll: $(list).data("btn-text"),
      isShowAll: false,
      showall_url:`${rootUrl}/product/freeship`
    };
    var ts = h(ProductScrollList, props);
    productList[$(list).attr("id")] = ReactDOM.render(ts, list);
  });
};

const ContentProductScrollList = function () {
  let lists = $("oliver-product-slider");
  let w = $(window).innerWidth();
  if (Number(w) > 999) {
     $(".o-p-s").hide();
      return;
     }
  lists.each(function (idx, list) {
    let _url = `${rootUrl}/articles/loadProductSlider?`;
    _url = _url + "&content_id=" + $(list).attr("content_id");
    _url = _url + "&keyword=" + $(list).attr("keyword");
    _url = _url + "&limit=" + $(list).attr("limit");
    let content_id = $(list).attr("content_id");
    let elId = `wh_product_slider_${idx}`;
    let props = {
      title: "",
      ajax_url: _url,
      ele_id: elId,
      type: "content_product",
      page: 1,
      showAll: "",
      isShowAll: false
    };
    $(list).replaceWith(`<div class="o-p-s" id='${elId}'></div>`);
    let ts = h(ProductScrollList, props);
    productList[elId] = ReactDOM.render(ts, document.getElementById(elId));
  });

};

function FavouriteProductsScrollList() {
  var lists = $("div.favourite-products-container");
  lists.each(function(idx, list){
    var props = {
      title: $(list).data("title-text"),
      ajax_url: `${rootUrl}/product/wishlistfull`,
      ele_id: $(list).attr("id"),
      type: "wish_list",
      page: 1,
      showAll: $(list).data("btn-text"),
      isShowAll: false,
      showall_url:`${rootUrl}/product/wishlistfull`,
      canDeleteItem: true,
      deleteUrl: `${rootUrl}/product/wishlist`,
      deleteImgPath: $(list).data("delete-img-path")
    };
    var ts = h(ProductScrollList, props);
    productList[$(list).attr("id")] = ReactDOM.render(ts, list);
  });
}

function BookmarkedContentScrollList() {
  var ele = $("#bookmarked_articles");
  if (ele.length == 0) return;
  var props = {
    title: $("#bookmarked_articles").data("title-text"),
    url: `${rootUrl}/customer/bookmarkedarticles`,
    ele_id: "bookmarked_articles",
    type: "bookmarked",
    page: 1,
    itemWidth: articleItemWidth,
    minSlides: 1,
    showAll: $("#bookmarked_articles").data("btn-text"),
    isShowAll: false,
    showall_url:`${rootUrl}/${ARTICLE_LINK}`,
    canDeleteItem: true,
    deleteUrl: `${rootUrl}/customer/bookmark`,
    deleteImgPath: $("#bookmarked_articles").data("delete-img-path")
  };
  var ts = h(ArticleScrollList, props);
  productList[$(ele).attr("id")]=ReactDOM.render(ts, $('#bookmarked_articles')[0]);
}

function productDetailEventsBinding() {
  $("div.product-detail button[name='prod_add2bakset']").on("click",function(evt){
    evt.stopPropagation();
    add2basket(this,$(this).data("pid"),"product_detail",$(this).data("price"));
  });
  fvBindingEvents();
}

function loadProductLists() {
  productLatest();
  productTopsale();
  articlesLatest();
  articlesRelated();
  TopSaleProductsScrollList();
  ProductTypeList();
  RelatedProductsScrollList();
  TipsProductsScrollList();
  ContentProductScrollList();
  SameAsProductsScrollList();
  productDirectSearch();
  productDetailEventsBinding();
  ContentInstagramGridLoad();
}

function checkoutProductLists() {
  CrossSaleProductsScrollList();
  FreeshipProductsScrollList();
}

function contentProductList() {
  ProductTopSaleInContentList();
}

const ContentInstagramGridLoad = function () {
  let ele = $("oliver-instagram-grid");
  if (ele.length == 0) return;
  $(ele).replaceWith(`<div class="instagram-grid-container"></div>`);
  var ts = h(InstagramImageGrid, {});
  productList["oliverInstagramGrid"] = ReactDOM.render(ts, $(".instagram-grid-container")[0]);
}

export {loadProductLists,
        checkoutProductLists,
        productList,
        contentProductList,
        CrossSaleProductsScrollList,
        FreeshipProductsScrollList,
        FavouriteProductsScrollList,
        BookmarkedContentScrollList
      };
